/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { UserNotificationEmail } from './UserNotificationEmail'
import {
  UserNotificationEmailFromJSON,
  UserNotificationEmailFromJSONTyped,
  UserNotificationEmailToJSON,
} from './UserNotificationEmail'

/**
 *
 * @export
 * @interface GetNotificationEmails200Response
 */
export interface GetNotificationEmails200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetNotificationEmails200Response
   */
  status: boolean
  /**
   *
   * @type {Array<UserNotificationEmail>}
   * @memberof GetNotificationEmails200Response
   */
  data: Array<UserNotificationEmail>
}

/**
 * Check if a given object implements the GetNotificationEmails200Response interface.
 */
export function instanceOfGetNotificationEmails200Response(
  value: object
): value is GetNotificationEmails200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetNotificationEmails200ResponseFromJSON(
  json: any
): GetNotificationEmails200Response {
  return GetNotificationEmails200ResponseFromJSONTyped(json, false)
}

export function GetNotificationEmails200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNotificationEmails200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(UserNotificationEmailFromJSON),
  }
}

export function GetNotificationEmails200ResponseToJSON(
  value?: GetNotificationEmails200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(UserNotificationEmailToJSON),
  }
}
